export default __webpack_public_path__ + "static/media/bellIcon.f6c0ae53.svg";